import { AppState } from '../store';

export const authSelector = (state: AppState) => state.userReducer;
